module.exports = __webpack_public_path__ + "media/top/icon_location_36x36-64c99091.svg";